export var MuiList = {
  styleOverrides: {
    root: {
      padding: 0
    }
  }
};
//# sourceMappingURL=MuiList.js.map